import React, { useMemo } from 'react';

import MediaTypography from 'components/MediaTypography';
import useAnchorEl from 'hooks/useAnchorEl';

import type { TRange } from '@common/helpers/useRangeDateQuery';

import { StyledDatePickerCalendarMonth, StyledDatePickerWrap } from '../styled';
import DateRangePickerPopover, { CalendarPopoverProps } from './Popover';

export interface DateRangeCalendarProps
	extends Omit<CalendarPopoverProps, 'onClose' | 'isCalendarOpen' | 'anchorEl'> {}

const formatRangeToString = (range: TRange) => {
	const [startDate, endDate] = range;

	if (!startDate && !endDate) return '';

	const startStr = startDate ? startDate.toFormat('dd.MM.yyyy') : '';
	const endStr = endDate ? endDate.toFormat('dd.MM.yyyy') : '';

	return startStr && endStr ? `${startStr} - ${endStr}` : startStr || endStr;
};

function DateRangeCalendar({ value, onChange, ...props }: DateRangeCalendarProps) {
	const { anchorEl, open, handleClose, handleOpen } = useAnchorEl();

	const label = useMemo(() => formatRangeToString(value), [value]);

	return (
		<>
			<StyledDatePickerWrap className="datePicker">
				<MediaTypography
					variant="h4"
					variants={{ xs: 'subtitle2' }}
					sx={{ fontVariantNumeric: 'tabular-nums' }}
				>
					{label}
				</MediaTypography>
				<StyledDatePickerCalendarMonth onClick={handleOpen} />
			</StyledDatePickerWrap>
			<DateRangePickerPopover
				isCalendarOpen={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				value={value}
				onChange={onChange}
				{...props}
			/>
		</>
	);
}

export default DateRangeCalendar;
